var BreakPoints = {
    addressXsMax: 600,
    xsMax: 768,
    smMax: 992,
    mdMax: 1200
};

export default BreakPoints;
